import { parseBraSize } from '~/techstyle-shared/react-components/src/utils/sizes';

import {
  clothingSizes,
  getPdpClothingSizes,
  PROFILE_KEYS,
} from '../constants/productSizes';

export function getProfileFilterValue({
  profileKey,
  profileValue,
  isPdp = false,
  subField,
  tldLocale,
}) {
  const sizeMapping = isPdp ? getPdpClothingSizes(tldLocale) : clothingSizes;

  switch (profileKey) {
    case PROFILE_KEYS.BRA_SIZE:
      if (subField && subField === 'size_cup') {
        return parseBraSize(profileValue)[1];
      } else if (subField && subField === 'size_band') {
        return parseBraSize(profileValue)[0];
      } else {
        return getMappedProfileValue({ sizeMapping, profileValue });
      }

    case PROFILE_KEYS.BOTTOM_SIZE:
    case PROFILE_KEYS.TOP_SIZE:
    case PROFILE_KEYS.LINGERIE_SIZE:
    case PROFILE_KEYS.BRALETTE_SIZE:
    case PROFILE_KEYS.DRESS_SIZE:
    case PROFILE_KEYS.ONE_PIECE_SIZE:
      return getMappedProfileValue({ sizeMapping, profileValue });
    case PROFILE_KEYS.SHOE_SIZE:
      // Shoe sizes are already valid as-is.
      return profileValue.toString();
  }
}

/***
 * This function is used to map the profile value to the size mapping.
 * By default it looks it up in the mapping. If not found, it checks if the value is a valid size.
 *
 * @param {Object} params - The parameters object.
 * @param {Object} params.sizeMapping - The size mapping object.
 * @param {string} params.profileValue - The profile value to be mapped.
 * @returns {string|null} - The mapped profile value or null if not found.
 */
export const getMappedProfileValue = ({ sizeMapping, profileValue }) => {
  if (!profileValue) {
    return null;
  }

  // normal lookup
  const mappedValue = sizeMapping[profileValue];
  if (mappedValue) {
    return mappedValue;
  }

  // If the value is not found in the mapping, check if it is a valid size and just old
  return Object.values(sizeMapping).includes(profileValue)
    ? profileValue
    : null;
};
